import ApisServiceApp from '@api/ApisServiceApp'
import ApisServiceAuth from '@api/ApisServiceAuth'
import { IChiNhanhCapNhatThongTinBody } from '@interfaces/chiNhanhInterfaces'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

export function getDetailChiNhanh(id: string) {
  try {
    return ApisServiceAuth.get('/chinhanh/' + id + '/get-chitiet-chinhanh')
  } catch (err: any) {
    handleError(err)
    throw err
  }
}


export function getListChiNhanh(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisServiceAuth.get('/chinhanh/filter-chinhanh', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

/** PUT /chi-nhanh/{id}/cap-nhat-chi-nhanh */
export function putCapNhatChiNhanh(id: number, body: IChiNhanhCapNhatThongTinBody) {
  return ApisServiceApp.put(`/chi-nhanh/${id}/cap-nhat-chi-nhanh`, body)
}

export function getChiNhanhFormKho(id: number) {
  return ApisServiceApp.get('/chi-nhanh/' + id + '/chi-tiet-chi-nhanh')
}
